import { createOptimizedPicture } from '../../scripts/aem.js';
import { div as divElem } from '../../scripts/dom-helpers.js';
import 'nsw-design-system/src/components/hero-banner/_hero-banner.scss';
import './banner.scss';

function getBannerVariation(className) {
  if (className.includes('off-white')) {
    return { bannerVariant: 'off-white', buttonClass: 'dark' };
  }

  if (className.includes('white')) {
    return { bannerVariant: 'true', buttonClass: 'dark' };
  }

  if (className.includes('light')) {
    return { bannerVariant: 'light', buttonClass: 'dark' };
  }

  if (className.includes('supplementary')) {
    return { bannerVariant: 'supplementary', buttonClass: 'light' };
  }

  return { bannerVariant: 'dark', buttonClass: 'white' };
}

function determineColumnLayout(col1, col2, block) {
  let textCol = col1;
  let mediaCol = col2;

  if (col1?.querySelector('img')) {
    textCol = col2;
    mediaCol = col1;
    block.classList.add('flipped');
  }

  return { textCol, mediaCol };
}

function extractButtonInfo(buttonContainer) {
  if (!buttonContainer) {
    return { buttonText: '', buttonUrl: '', buttonIcon: '' };
  }

  const anchorElem = buttonContainer.querySelector('a');
  const buttonIcon = anchorElem?.querySelector('.icon');
  const buttonText = Array.from(anchorElem.childNodes)
    .filter((node) => node.nodeType === Node.TEXT_NODE)
    .map((node) => node.textContent.trim())
    .join('');
  const buttonUrl = anchorElem.href;

  return { buttonText, buttonUrl, buttonIcon };
}

function handleBannerTypeContent(bannerType, banner, mediaCol) {
  const TEXT_ELM_PATHS = 'p, h1, h2, h3, h4, h5, h6, ul';
  let [x, y] = [50, 50];

  if (bannerType === 'image') {
    const mediaImage = mediaCol.querySelector('img');
    if (mediaImage.dataset.title?.includes('data-focal')) {
      const dataString = mediaImage.dataset.title.split(':');
      [x, y] = String(dataString[1]).split(',');
    }

    const optimizedPic = createOptimizedPicture(mediaImage.src, mediaImage.alt, false, [{ width: '750' }]);

    const optimizedImg = optimizedPic.querySelector('img');
    // SWS-1515 Focal Point implementation
    optimizedImg.style.objectPosition = `${x}% ${y}%`;
    optimizedImg.style.objectFit = 'cover';

    optimizedPic.classList.add('nsw-hero-banner__image');
    banner.querySelector('.nsw-hero-banner__box').innerHTML = optimizedPic.outerHTML;
  }

  if (bannerType === 'links') {
    const linkList = mediaCol.querySelector('ul');
    const linkItems = [...linkList.children].map((link) => {
      const linkText = link.innerText.trim();
      const linkUrl = link.querySelector('a')?.href;
      const linkTitle = link.querySelector('a')?.title;
      return `<li><a href="${linkUrl}" alt="${linkTitle}" title="${linkTitle}">${linkText}</a></li>`;
    });

    const linksWrapper = divElem({ class: 'nsw-hero-banner__links' });
    linksWrapper.innerHTML = ` 
      <div class="nsw-hero-banner__list">
      <ul>${linkItems.join('')}</ul>
      </div>`;

    const linksTitle = mediaCol.querySelector(TEXT_ELM_PATHS);
    if (linksTitle) {
      const linksTitleElem = divElem({ class: 'nsw-hero-banner__sub-title' });
      linksTitleElem.innerText = linksTitle.innerText.trim();
      linksWrapper.querySelector('.nsw-hero-banner__list').prepend(linksTitleElem);
    }

    banner.querySelector('.nsw-hero-banner__wrapper').append(linksWrapper);
  }
}

export default async function decorate(block) {
  const [col1, col2] = [...block.firstElementChild.children];
  const TEXT_ELM_PATHS = 'p, h1, h2, h3, h4, h5, h6, ul';

  const { textCol, mediaCol } = determineColumnLayout(col1, col2, block);
  const { bannerVariant, buttonClass } = getBannerVariation(block.getAttribute('class'));

  let bannerType = 'wide';
  if (mediaCol?.querySelector('img')) {
    bannerType = 'image';
  }
  if (mediaCol?.querySelector('ul')) {
    bannerType = 'links';
  }

  const [title, ...description] = textCol.querySelectorAll(TEXT_ELM_PATHS);

  let buttonContainer = null;
  if (description.length && description[description.length - 1]?.classList.contains('button-container')) {
    buttonContainer = description.pop();
  }

  const descriptionWrapper = divElem();
  description.forEach((row) => {
    row.classList.add('nsw-intro');
    descriptionWrapper.appendChild(row);
  });

  const { buttonText, buttonUrl, buttonIcon } = extractButtonInfo(buttonContainer);

  // Extract nested ternary operations into independent statements
  const titleHtml = title?.outerHTML ?? '';
  const iconHtml = buttonIcon?.outerHTML ?? '';
  const buttonHtml = buttonText
    ? `<div class="nsw-hero-banner__button">
          <a href="${buttonUrl}" class="nsw-button nsw-button--${buttonClass}">${buttonText}
          ${iconHtml}
          </a>
        </div>`
    : '';

  const banner = divElem({ class: `nsw-hero-banner nsw-hero-banner--${bannerVariant}` });
  const bannerTemplate = `
    <div class="nsw-hero-banner__container">
    <div class="nsw-hero-banner__wrapper">
      <div class="nsw-hero-banner__content">
      ${titleHtml}
      ${descriptionWrapper.innerHTML}
      ${buttonHtml}
      </div>
      <div class="nsw-hero-banner__box">
      </div>
    </div>
    </div>`;

  banner.innerHTML = bannerTemplate;

  if (bannerType === 'wide') {
    banner.classList.add('nsw-hero-banner--wide');
  }

  handleBannerTypeContent(bannerType, banner, mediaCol);

  block.innerHTML = banner.outerHTML;
}
